import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { SearchTransactionV2Model } from './search-transaction.model';
import { TransactionV2ListModel } from './transaction-list.model';

const apiUrl = `/api/transactions`;

export const transactionV2Client = {
  get: (id: string): Promise<TransactionV2ListModel> => {
    return baseClient.get<TransactionV2ListModel>(`${apiUrl}/v2/${id}`);
  },

  list: (
    model: SearchTransactionV2Model,
  ): Promise<ResultListModel<TransactionV2ListModel>> => {
    return baseClient.body<
      SearchTransactionV2Model,
      ResultListModel<TransactionV2ListModel>
    >({
      body: model,
      method: 'POST',
      url: `${apiUrl}/v2/list`,
    });
  },
};
